export function hueFromKey(key: string): number {
  let hash = 0
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0
  }
  return Math.abs(hash) % 360
}

export function headerBg(hue: number): string {
  return `hsl(${hue} 45% 94%)`
}

export function headerText(hue: number): string {
  return `hsl(${hue} 40% 30%)`
}

export function edgeColor(hue: number): string {
  return `hsl(${hue} 30% 70%)`
}
